import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

interface Ticket {
    id: number;
    title: string;
    description: string;
    status: string;
    user_id: string;
    created_at: string;
    updated_at: string;
    resolved_at: string | null;
}

interface GetTicketDetailResponse {
    meta: {
        error: boolean;
        code: number;
        message: string;
    };
    data: Ticket;
}

export const getTicketDetail = async (id: number) => {
    try {
        const response = await Axios.get(`/tickets/${id}/`);
        return response.data as GetTicketDetailResponse;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetTicketDetail = (id: number) => {
    const ticket = useQuery({
        queryKey: ["get-ticket-detail", id],
        queryFn: () => getTicketDetail(id),
        enabled: !!id, // Only run query if id is provided
    });

    return ticket;
};